/**
 * The single TanStack Query client (frontend-map §3.2). Imported by __root.tsx.
 *
 * Phase 1 defaults: modest staleTime; NO refetch-on-focus for the library
 * (focus/interval polling is a Phase 3 trip concern, T22 — do not enable here).
 * Do not retry 4xx — a 403/404 won't fix itself.
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
